import axios from 'axios';
import authHeader from "@/service/auth-header";

class PaymentImportService {

    async importFinancialTransactions(companyId, type, data) {
        return await axios.post(`/api/paymentimport/import/${companyId}/${type}`, data, { headers: authHeader() });
    }

}

export default new PaymentImportService();
